import React from 'react';
import RoyalsTeamStoreSvg from "./RoyalsTeamStoreSvg.js";
import StoreMapCanvas from "../../../../pages/Retail/map/StoreMapCanvas.js";

export const ANALYTICS_CONFIG = {
  mapColClass: "col-md-7",
  listColClass: "col-md-5",
  mapMaxWidth: "100%",
  mapWidth: "100%"
};

// Royals Team Store SVG viewBox dimensions
const SVG_WIDTH = 962.24646;
const SVG_HEIGHT = 581.778992;

// Numbers are placed by the shared canvas from each zone's shape
// (or a zone's labelPosition in locations.json, if set).

const RoyalsTeamStoreMap = (props) => (
  <StoreMapCanvas
    {...props}
    Background={RoyalsTeamStoreSvg}
    width={SVG_WIDTH}
    height={SVG_HEIGHT}
    maxHeight={540}
  />
);

export default RoyalsTeamStoreMap;
